import { render, staticRenderFns } from "./afegeixUsers.vue?vue&type=template&id=3e719db7"
import script from "./afegeixUsers.vue?vue&type=script&lang=js"
export * from "./afegeixUsers.vue?vue&type=script&lang=js"
import style0 from "./afegeixUsers.vue?vue&type=style&index=0&id=3e719db7&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports